import momentTz from 'moment-timezone'

const datetimeRegExp = (/(\d{1,2})[//.-](\d{1,2})[//.-](\d{4}) (\d{2}):(\d{2})/);

function addPaddingZero(val) {
  return val<10 ? '0'+val : val;
}

//TODO: get settings from backend
const userSettings = {
    //df: '.YMD'
  };

  var _moment = {'version': '2.18.1', 'fn': {}, 'ctz': null,
  getZoneData: function (timestamp) {
    if (!momentTz.ctz) momentTz.ctz = momentTz.tz.zone(userSettings.tz || 'Etc/UTC');
    var ind = momentTz.ctz._index(timestamp);
    return {offset: momentTz.ctz.offsets[ind], abbr: momentTz.ctz.abbrs[ind]};
  },
  parse: function (timestamp) {
    if (!momentTz.tz) return 0;
    if (!momentTz.ctz) momentTz.ctz = momentTz.tz.zone(userSettings.tz || 'Etc/UTC');
    return momentTz.ctz.parse(timestamp);
  },
  getY: function (date) { return date.getUTCFullYear(); },
  getM: function (date) { return addPaddingZero(date.getUTCMonth()+1); },
  getD: function (date) { return addPaddingZero(date.getUTCDate()) },
  getV: function (date, nm) { return _moment['get'+nm](date); }
};

export default {
  methods: {
    getTimestamp(datetime) {
      var res = datetime.match(datetimeRegExp);
      return Date.UTC(res[3], res[2] - 1, res[1], res[4], res[5]);
    },

    fixTimestamp(timestamp, timefirst, isHideZone) {
      var d = _moment.getZoneData(timestamp), date = new Date(timestamp - (d.offset * 60000)),
      df = userSettings.df || '.DMY', delim = df[0],
      time = addPaddingZero(date.getUTCHours()) + ':' + addPaddingZero(date.getUTCMinutes());
      return (timefirst ? time + ' ' : '') +
      _moment.getV(date, df[1]) + delim + _moment.getV(date, df[2]) + delim + _moment.getV(date, df[3]) +
      (timefirst ? '' : ' ' + time) + (d.abbr == 'UTC' || isHideZone ? '' : ' ' + d.abbr);
    },
    toHHMM(sec, defVal = 'unknown') {
      if (sec <= 0) return defVal;
      var sec_num = parseInt(sec);
      if (isNaN(sec_num)) {
        return defVal;
      }
      var hours = Math.floor(sec_num / 3600);
      var minutes = Math.ceil((sec_num - (hours * 3600)) / 60);

      return addPaddingZero(hours) + ':' + addPaddingZero(minutes);
    },
    toHHMMSS(sec,h24format, defVal = 'unknown') {
      if (sec<=0) return defVal;
      var sec_num = parseInt(sec);
      if (isNaN(sec_num)) {
        return defVal;
      }
      var hours   = Math.floor(sec_num / 3600);
      var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
      var time    =  addPaddingZero(hours)+':'+addPaddingZero(minutes);
      if ( h24format || h24format == undefined ) {
        time += ':' + addPaddingZero(sec_num % 60);
      }
      return time;
    },
    addPaddingZero
  }
}
